import { render, staticRenderFns } from "./BadgeSection.vue?vue&type=template&id=58f25b00&scoped=true"
import script from "./BadgeSection.vue?vue&type=script&lang=js"
export * from "./BadgeSection.vue?vue&type=script&lang=js"
import style0 from "./BadgeSection.vue?vue&type=style&index=0&id=58f25b00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f25b00",
  null
  
)

export default component.exports